import { Box, Button, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React, { FC, useState } from "react";
import {
  DetailsHospitalUI,
  DetailsUI,
  EmployeeRequest,
  PersonnelHighlight,
  ProfileHospitalUI,
  ProfileUI,
  VerificationHospitalUI,
} from "../BoxUI";
import BarChart from "../charts/barChart";
import LineChart from "../charts/lineChart";
import useResponsive from "../../hooks/useResponsive";
import { Dot } from "../UIElements/svgIcons";
import DotDropDown from "../UIElements/dot-dropdown";
import { FacilityListProps } from "../../interface/facility";
import { formatDateFromString, formatTextType } from "../../utils/url-id";
import FacilityInfo from "./facilityInfo";
import { btnSty } from "../ui-styles";
import JobFacility from "./jobFacility";
import EmployeeFacility from "./employeeFacility";
import { VerifyHospitalModal } from "./modal-contents";
import { useLocation, useNavigate } from "react-router-dom";

const HospitalDetailsContent: FC<{
  facilityInfo: FacilityListProps;
  loading: boolean;
}> = ({ facilityInfo, loading }) => {
  const theme = useTheme();
  const isMedium = useResponsive("down", "md", "xl");
  const navigate = useNavigate();
  const location = useLocation();
  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = () => setOpenModal(!openModal);

  const headerSty = {
    fontFamily: "Lexend",
    fontWeight: 500,
    my: isMedium ? 2 : 3,
    color: theme.palette.neutral.light,
  };

  return (
    <>
      {/* <FacilityInfo /> */}
      <VerifyHospitalModal open={openModal} modalHandler={handleOpenModal} />
      <Box
        sx={{
          margin: 3,
          padding: isMedium ? 3 : 4,
          borderRadius: "3px",
          minHeight: "100%",
          backgroundColor: theme.palette.common.white,
        }}
      >
        <Stack
          direction="row"
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Typography sx={{ ...headerSty, my: 0, mb: 2 }} variant="subtitle2">
            Hospital Profile
          </Typography>
        </Stack>
        <ProfileHospitalUI
          name={facilityInfo.name}
          email={facilityInfo.email}
          facilityId={facilityInfo._id}
        />
        <Stack
          direction="row"
          justifyContent={"space-between"}
          alignItems={"center"}
          sx={{ my: 2 }}
        >
          <Typography sx={headerSty} variant="subtitle2">
            Hospital Details
          </Typography>
          {facilityInfo?.verification != "vetted" && (
            <Button
              variant="contained"
              onClick={handleOpenModal}
              sx={{ width: 150 }}
            >
              Verify Hospital
            </Button>
          )}
        </Stack>
        <DetailsHospitalUI
          type={formatTextType(facilityInfo.type)}
          size={facilityInfo?.facility_size ?? "-"}
          IsVerified={
            !!facilityInfo.isVerified ? facilityInfo.isVerified : false
          }
          JoinedOn={formatDateFromString(facilityInfo.created_at) ?? "-"}
        />

        <VerificationHospitalUI
          specialties={facilityInfo?.specialties ?? ""}
          state={facilityInfo?.state ?? "-"}
          verification={facilityInfo?.verification ?? "-"}
          reg_no={facilityInfo?.reg_no ?? "-"}
          level={facilityInfo?.level ?? "-"}
        />

        {/* <Typography sx={headerSty} variant="subtitle2">
        Personnel highlight
      </Typography>
      <PersonnelHighlight
        doctors={"24"}
        nurses={"213"}
        support={"82"}
        student={"14"}
        available_jobs={"14"}
        total_jobs={"140"}
      /> */}

        <Stack direction="row" spacing={3} sx={{ my: 3 }}>
          <Button
            onClick={() => navigate(location.pathname + "/employees")}
            variant="contained"
            sx={{ minWidth: 150 }}
          >
            Facility Employees
          </Button>
          <Button
            onClick={() => navigate(location.pathname + "/jobs")}
            variant="contained"
            sx={{ minWidth: 150 }}
          >
            Facility Jobs
          </Button>
        </Stack>
      </Box>
    </>
  );
};

export default HospitalDetailsContent;
